import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Divider, Flex, Heading, IconBulb, IconHOA, IconMail, Paragraph, Spacer } from '@zillow/constellation';
import { URLS } from '../../../constants/urls';
import styled from 'styled-components';

const LineItem = ({ id, icon, learnMoreHref, textContent }) => {
  const IconComponent = icon;

  return (
    <Flex display="flex" marginBottom="sm" gap="sm">
      <div>
        <IconComponent fontColor="blue400" size="sm" />
      </div>
      <Paragraph>
        {textContent}{' '}
        <Anchor rel="noreferrer" href={learnMoreHref} target="_blank" data-test={id}>
          Learn more
        </Anchor>
      </Paragraph>
    </Flex>
  );
};

LineItem.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  learnMoreHref: PropTypes.string.isRequired,
  textContent: PropTypes.string.isRequired,
};

const StyledDivider = styled(Divider)`
  width: 100%;
`;

const LegalConsiderations = () => {
  return (
    <>
      <Flex display="flex" alignItems="center" marginBottom="md" gap="xs">
        <StyledDivider />
        <div>
          <IconBulb fontColor="borderLight" size="xs" />
        </div>
        <StyledDivider />
      </Flex>
      <Heading level={5} marginBottom="sm" fontColor="brand" fontFamily="serif">
        Legal considerations for landlords
      </Heading>
      <Spacer padding="sm">
        <LineItem
          id="legal-considerations__hud"
          icon={IconHOA}
          learnMoreHref={URLS.HUD}
          textContent={`Tenant screening policies that automatically disqualify applicants based on their criminal background may violate the Fair Housing Act. It's best to assess each applicant's record individually. Additional state and local restrictions may apply.`}
        />
        <LineItem
          id="legal-considerations__ftc"
          icon={IconMail}
          learnMoreHref={URLS.FTC_CONSUMER_REPORTS}
          textContent={`If you take any adverse action, such as declining an application, based partly or completely on information in a consumer report, the Fair Credit Reporting Act requires that you send the applicant an adverse action notice informing them of their right to see data reported about them so they can correct any inaccurate information. Additional state and local restrictions may apply.`}
        />
      </Spacer>
      <Paragraph marginBottom="xl">
        Please ensure that you comply with federal, state, and local laws. For legal advice, consult a local attorney.
      </Paragraph>
    </>
  );
};

export default LegalConsiderations;
